import React, { useState } from 'react';

const API_BASE = 'https://www.nvmonitor.com.br';

const PERFIS = [
  { valor: 'pessoa_fisica', label: 'Pessoa física — quero começar do zero' },
  { valor: 'empresa_migrando', label: 'Já tenho uma empresa — quero migrar ou expandir' },
  { valor: 'cooperativa', label: 'Cooperativa ou associação' },
];

export default function CTAForm() {
  const [campos, setCampos] = useState({ nome: '', empresa: '', email: '', telefone: '', cidade: '', perfil: '', mensagem: '', empresa_hp: '' });
  const [erros, setErros] = useState({});
  const [status, setStatus] = useState(null); // null | 'enviando' | 'sucesso' | 'erro'

  const atualizar = (campo) => (e) => setCampos((c) => ({ ...c, [campo]: e.target.value }));

  const validar = () => {
    const novosErros = {};
    if (!campos.nome.trim()) novosErros.nome = true;
    if (!/\S+@\S+\.\S+/.test(campos.email)) novosErros.email = true;
    if (campos.telefone.trim().length < 8) novosErros.telefone = true;
    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const enviar = async (e) => {
    e.preventDefault();

    // honeypot — se preenchido, é bot; finge sucesso e não envia nada
    if (campos.empresa_hp) {
      setStatus('sucesso');
      setCampos({ nome: '', empresa: '', email: '', telefone: '', cidade: '', perfil: '', mensagem: '', empresa_hp: '' });
      return;
    }

    if (!validar()) return;

    setStatus('enviando');
    try {
      const perfilLabel = PERFIS.find((p) => p.valor === campos.perfil)?.label || '';
      const r = await fetch(`${API_BASE}/api/leads-parceiro`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: campos.nome.trim(),
          empresa: campos.empresa.trim(),
          email: campos.email.trim(),
          telefone: campos.telefone.trim(),
          cidade: campos.cidade.trim(),
          perfil: perfilLabel,
          mensagem: campos.mensagem.trim(),
        }),
      });
      if (!r.ok) throw new Error('Falha no envio');
      setStatus('sucesso');
      setCampos({ nome: '', empresa: '', email: '', telefone: '', cidade: '', perfil: '', mensagem: '', empresa_hp: '' });
    } catch {
      setStatus('erro');
    }
  };

  return (
    <section id="form" className="cta-final">
      <div className="container">
        <div className="cta-grid">
          <div className="cta-side">
            <div className="eyebrow">Próximo passo</div>
            <h2>Sua empresa de rastreamento pode começar essa semana</h2>
            <p className="lead">Fala com a gente. A gente entende sua operação e mostra como a Nivocar se encaixa nela — não importa se você está começando agora ou já tem uma operação rodando.</p>
            <ul className="cta-check-list">
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                Pessoa física começando do zero
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                Empresa que já rastreia e quer migrar ou expandir
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                Cooperativa ou associação de proteção veicular
              </li>
            </ul>
          </div>

          <form className="lead-form" onSubmit={enviar} noValidate>
            <input type="text" className="hp" tabIndex="-1" autoComplete="off" value={campos.empresa_hp} onChange={atualizar('empresa_hp')} />

            <div className="form-row">
              <div className={`field${erros.nome ? ' invalid' : ''}`}>
                <label htmlFor="nome">Nome*</label>
                <input id="nome" value={campos.nome} onChange={atualizar('nome')} />
                <div className="field-error">Preenche seu nome pra gente saber com quem falar.</div>
              </div>
              <div className="field">
                <label htmlFor="empresa">Empresa (se já tiver)</label>
                <input id="empresa" value={campos.empresa} onChange={atualizar('empresa')} />
              </div>
            </div>

            <div className="field">
              <label htmlFor="perfil">Qual seu perfil?</label>
              <select id="perfil" value={campos.perfil} onChange={atualizar('perfil')}>
                <option value="">Selecione uma opção</option>
                {PERFIS.map((p) => (
                  <option key={p.valor} value={p.valor}>{p.label}</option>
                ))}
              </select>
            </div>

            <div className="form-row">
              <div className={`field${erros.email ? ' invalid' : ''}`}>
                <label htmlFor="email">Email*</label>
                <input id="email" type="email" value={campos.email} onChange={atualizar('email')} />
                <div className="field-error">Coloca um email válido pra gente responder.</div>
              </div>
              <div className={`field${erros.telefone ? ' invalid' : ''}`}>
                <label htmlFor="telefone">Telefone*</label>
                <input id="telefone" type="tel" placeholder="(00) 00000-0000" value={campos.telefone} onChange={atualizar('telefone')} />
                <div className="field-error">Precisamos do telefone pra entrar em contato.</div>
              </div>
            </div>

            <div className="field">
              <label htmlFor="cidade">Cidade</label>
              <input id="cidade" value={campos.cidade} onChange={atualizar('cidade')} />
            </div>

            <div className="field">
              <label htmlFor="mensagem">Conta um pouco da sua operação (opcional)</label>
              <textarea id="mensagem" placeholder="Quantos veículos, se já trabalha com rastreamento hoje, etc." value={campos.mensagem} onChange={atualizar('mensagem')} />
            </div>

            <div className="form-submit-row">
              <button type="submit" className="btn btn-primary" disabled={status === 'enviando'}>
                {status === 'enviando' ? 'Enviando...' : 'Enviar interesse'}
              </button>
              {status === 'sucesso' && <span className="form-msg success">Recebemos seu contato. Alguém da Nivocar fala com você em breve.</span>}
              {status === 'erro' && <span className="form-msg error">Não deu pra enviar agora. Tenta de novo ou chama no WhatsApp.</span>}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
